// @flow

import React, { Component } from 'react';
import styled from 'styled-components';

import { colors } from '../../style';
import { fetchBook } from '../../api';

import DownloadIcon from '../Book/DownloadIcon';
import arrowSrc from './arrow.svg';
import crossSrc from './cross.svg';

const Root = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 60;

  background-color: ${colors.peach};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`

const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
`

const PaginationCurrent = styled.span`
  font-weight: bold;
  color: ${colors.red};
`

const PrevButton = styled.button`
  padding: 6px 30px;

  border: none;
  outline: none;
  cursor: pointer;

  background: transparent;
  background-image: url(${arrowSrc});
  background-repeat: no-repeat;
  background-position: center;
`

const NextButton = styled(PrevButton)`
  transform: rotate(180deg);
`

const Viewport = styled.div`
  display: flex;
  justify-content: space-between;

  height: 720px;

  user-select: none;
`

const Page = styled.div`
  flex-basis: 50%;
  background-color: white;
`

const PageImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const CloseButton = styled.button`
  padding: 15px;

  border: none;
  outline: none;
  cursor: pointer;

  background: transparent;
  background-image: url(${crossSrc});
  background-repeat: no-repeat;
  background-position: center;
`

type Props = {
  locale: string,
  onClose: Function,
};

type State = {
  loading: boolean,
  error: null|string,
  currentPage: number,
  pages: Array<string>,
}

class PreviewBook extends Component<void, Props, State> {
  state: State;
  props: Props;

  bindedHandleKeyUp: Function;

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      currentPage: 1,
      pages: []
    }

    this.bindedHandleKeyUp = this.handleKeyUp.bind(this)
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('keyup', this.bindedHandleKeyUp);
    }

    this.requestBook()
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('keyup', this.bindedHandleKeyUp);
    }
  }

  requestBook = () => {
    this.setState({ loading: true, error: null }, () => {
      fetchBook()
        .then(book => {
          this.setState({ loading: false, pages: book.pages })
        }, error => {
          this.setState({ loading: false, error: (error.message || JSON.stringify(error, null, 2)) })
        })
    })
  }

  handleKeyUp(event: { keyCode: number }) {
    const { onClose } = this.props;

    switch (event.keyCode) {
      case 27: // ESC
        return onClose()
      case 37: // Left arrow
        return this.handlePrevClick()
      case 39: // Right arrow
      case 32: // Space
        return this.handleNextClick()
      default:
        return false
    }
  }

  handleNextClick = () => {
    this.setState(({ currentPage, pages }) => ({
      currentPage: currentPage === pages.length - 1 ? pages.length : (currentPage + 1) % pages.length
    }))
  }

  handlePrevClick = () => {
    this.setState(({ currentPage, pages }) => ({
      currentPage: currentPage === 1 ? pages.length : (currentPage - 1)
    }))
  }

  render() {
    const { onClose } = this.props;
    const { loading, error, currentPage, pages } = this.state;

    return (
      <Root>
        <Header>
          <a
            href="https://www.zeroone.st"
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadIcon
              width={31}
              height={20}
            />
          </a>
          {pages.length > 1 && (
            <Pagination>
              <PrevButton onClick={this.handlePrevClick} />
              <div>
                <PaginationCurrent>{currentPage}</PaginationCurrent> | {pages.length}
              </div>
              <NextButton onClick={this.handleNextClick} />
            </Pagination>
          )}
          <CloseButton onClick={onClose} />
        </Header>
        {loading && (
          <div>Loading...</div>
        )}
        {error && (
          <div>
            Something went wrong: {error}.
            <button onClick={() => this.requestBook()}>Try again</button>
          </div>
        )}
        {pages.length > 0 && (
          <Viewport>
            <Page onClick={this.handlePrevClick}>
              <PageImage src={pages[currentPage - 1]} />
            </Page>
            {pages[currentPage] && (
              <Page onClick={this.handleNextClick}>
                <PageImage src={pages[currentPage]} />
              </Page>
            )}
          </Viewport>
        )}
      </Root>
    )
  }
}

export default PreviewBook;



// WEBPACK FOOTER //
// ./src/components/PreviewBook/PreviewBook.js